import React, { Component } from "react";
import { connect } from "react-redux";
import DTTSChart from "../../components/bar-charts/DTTSChart";
import CustomSelect from "../../components/common/select/Select";
import PratDashboardMiddleware from "../../store/prat_middleware/pratDashboard/pratDashboardMiddleware";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DATA from "../../assets/data";
import { compare } from "../gt/validation/sort";
import CustomToast from '../../util-functions/customToast.jsx'

class DTTS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: [],
      selectedYear: "",
      selectedPromoType: [],
      data: [],
      popUp: false,
      years: DATA.YEARSPreVsPostOpso,
      promotionTypes: DATA.PROMO_TYPES,
      filePopUp: false,
      isDivision: false
    };
  }

  componentDidMount() {
    // Marking Promotion type TPR and all the years check on component mounting
    this.handlePromoTypeCheckonMounting(0);
    this.handleYearCheckonMounting(1);
    this.handleYearCheckonMounting(2);
    this.handleYearCheckonMounting(3);
    this.handleYearCheckonMounting(4);
    this.handleYearCheckonMounting(5);
    let arr = [];
    if (this.props.categories) {
      this.props.categories.forEach(item => {
        arr.push(item.guid);
      });
      this.setState(
        {
          selectedCategory: arr
        },
        () => {
          setTimeout(() => {
            this.handleSubmit();
          }, 700);
        }
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.categories !== this.props.categories) {
      let arr = []
      this.props.categories.forEach(item => {
        arr.push(item.guid)
      })
      this.setState({
        selectedCategory: arr
      }, () => {
        this.handleSubmit();
      })
    }
  }

  handleCategory = category => {
    let arr = [];
    if (category === null || category.length === 0) {
      this.setState(
        {
          selectedCategory: []
        },
        () => {
          this.handleSubmit();
        }
      );
    } else {
      category.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedCategory: arr }, () => {
        this.handleSubmit();
      });
    }
  };

  handleSubmit = () => {
    if (this.state.selectedPromoType.length) {
      if (this.state.selectedYear.length) {
        this.props.getDTTSChart(
          this.state.selectedCategory,
          this.state.selectedYear,
          this.state.selectedPromoType
        );
      } else {
        // ToastsStore.error("Year is not selected!");
        CustomToast('error', 'Year is not selected!')
      }
    } else {
      // ToastsStore.error("Promotion type is not selected!");
      CustomToast('error', 'Promotion type is not selected!')
    }
  };

  handleYearCheck = (ind) => {
    if (this.state.selectedYear.length === 5 && !this.state.years[ind].dtts) {
      CustomToast('warning', 'Can not select more than five years')
      return;
    }
    let newArray = [...this.state.years]
    newArray[ind] = { ...newArray[ind], dtts: !newArray[ind].dtts }
    // this.state.years[ind].dtts = !this.state.years[ind].dtts;
    this.setState(
      {
        years: newArray
      },
      () => {
        let filterCheckedValues = [];
        this.state.years.forEach(item => {
          if (item.dtts) {
            filterCheckedValues.push(item.value);
          }
        });
        this.setState(
          {
            selectedYear: filterCheckedValues
          },
          () => {
            this.handleSubmit();
          }
        );
      }
    );
  };

  handleYearCheckonMounting = (ind) => {
    this.state.years[ind].dtts = true;      // eslint-disable-line
    this.setState(
      {
        years: this.state.years
      },
      () => {
        let filterCheckedValues = [];
        this.state.years.forEach(item => {
          if (item.dtts) {
            filterCheckedValues.push(item.value);
          }
        });
        this.setState({
          selectedYear: filterCheckedValues
        });
      }
    );
  };

  handlePromoTypeCheckonMounting = (ind) => {
    this.state.promotionTypes[ind].dtts = true;       // eslint-disable-line
    this.setState(
      {
        promotionTypes: this.state.promotionTypes
      },
      () => {
        let filterCheckedValues = [];
        this.state.promotionTypes.forEach(item => {
          if (item.dtts) {
            filterCheckedValues.push(item.guid);
          }
        });
        this.setState({
          selectedPromoType: filterCheckedValues
        });
      }
    );
  };

  handlePromoTypeCheck = (ind) => {
    let newArray = [...this.state.promotionTypes]
    newArray[ind] = { ...newArray[ind], dtts: !newArray[ind].dtts }
    // this.state.promotionTypes[ind].dtts = !this.state.promotionTypes[ind].dtts;
    this.setState(
      {
        promotionTypes: newArray
      },
      () => {
        let filterCheckedValues = [];
        this.state.promotionTypes.forEach(item => {
          if (item.dtts) {
            filterCheckedValues.push(item.guid);
          }
        });
        this.setState(
          {
            selectedPromoType: filterCheckedValues
          },
          () => {
            this.handleSubmit();
          }
        );
      }
    );
  };

  handleDttsXlsxDownload = () => {
    if (this.state.selectedCategory.length) {
      this.props.downloadDttsXlsx(this.state.selectedCategory)
    } else {
      CustomToast('error', 'Category not selected!')
    }
  }

  render() {
    return (
      <div className="dtts-container">
        <div className="dtts-heading-cta">
          <span className="dtts-heading">DTTS 2017-{new Date().getFullYear()}</span>

          <CustomSelect.MyCustomSelect
            className='filter-font-size'
            placeholder={"Category"}
            allowSelectAll={true}
            isMulti
            options={
              this.props.categories
                ? !this.props.categories
                  ? void 0
                  : this.props.categories.sort(compare).map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            onChange={this.handleCategory}
            value={
              this.props.categories
                ? this.props.categories
                  .filter(item => {
                    return !this.state.selectedCategory
                      ? void 0
                      : this.state.selectedCategory.includes(item.guid);
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : void 0
            }
          />
          <div className="dtts-cta-container">
            <div className="funnel-filter-container">
              <img
                className="funnel-filter-image"
                src={require("../../assets/images/funnelFilter.svg")}
                onClick={() => {
                  this.setState({ popUp: !this.state.popUp });
                }}
                alt=''
              />

              {this.state.popUp ? (
                <ClickAwayListener
                  onClickAway={() => {
                    this.setState({ popUp: false });
                  }}
                >
                  <div
                    className="funnel-pop-up"
                    style={{ width: "215px" }}
                  >
                    <div className="popUp-columns">
                      <span className="popUp-heading">Type of Promo</span>

                      <div className="promo-column">
                        {this.state.promotionTypes.map((item, indx) => (
                          <span className="column-item" key={indx}>
                            <input
                              type="checkbox"
                              className="column-item-input"
                              checked={item.dtts}
                              onChange={() => this.handlePromoTypeCheck(indx)}
                            />
                            <label>{item.Label}</label>
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="popUp-columns">
                      <span className="popUp-heading">Year</span>
                      <div className="promo-column">
                        {this.state.years.map((item, indx) => (
                          <span className="column-item" key={indx}>
                            <input
                              type="checkbox"
                              className="column-item-input"
                              checked={item.dtts}
                              onChange={() => this.handleYearCheck(indx)}
                            />
                            <label>{item.label}</label>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              ) : null}
            </div>
            <img
              className="images-style"
              src={require("../../assets/images/refreshArrows.svg")}
              onClick={this.handleSubmit}
              alt=''
            />
            <div className="funnel-filter-container">
              <div style={{ display: 'flex', cursor: 'pointer' }}
                onClick={() => {
                  this.setState({ filePopUp: !this.state.filePopUp });
                }}
              >
                <img
                  className="image-transform"
                  src={require("../gt/images/dots.png")}
                  alt=''
                />
              </div>

              {this.state.filePopUp ? (
                <ClickAwayListener
                  onClickAway={() => {
                    this.setState({ filePopUp: false });
                  }}
                >
                  <div
                    className="funnel-pop-up"
                    style={{ width: "140px", height: 'auto', flexDirection:'column' }}
                  >
                    <span className="division-cta">
                      <input type='checkbox' checked={this.state.isDivision} onChange={() => this.setState({ isDivision: !this.state.isDivision })} />
                      <label>Division</label>
                    </span>
                    <button className='xlsx-download-cta' onClick={this.handleDttsXlsxDownload}>Download Excel</button>
                  </div>
                </ClickAwayListener>
              ) : null}
            </div>
          </div>
        </div>

        {this.props.isDTTSChartLoading ? (
          <div style={{ marginTop: "100px" }}>
            <img
              src={require("../../assets/images/barsLoader.svg")}
              style={{ width: "60px", height: "60px" }}
              alt=''
            />
          </div>
        ) : (
            <>
              {
                this.state.isDivision ?
                  <DTTSChart data={this.props?.DTTSChart.Division} ObjKey='DivisionName' />
                  :
                  <DTTSChart data={this.props?.DTTSChart.Category} ObjKey='CustomCatName' />
              }
            </>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    DTTSChart: state.PratDashboardReducer.DTTSChart,
    isDTTSChartLoading: state.PratDashboardReducer.isDTTSChartLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDTTSChart: (selectedCategory, selectedYear, selectedPromoType) => {
      return dispatch(
        PratDashboardMiddleware.getDTTSChart(
          selectedCategory,
          selectedYear,
          selectedPromoType
        )
      );
    },
    downloadDttsXlsx: (selectedCategory) => {
      return dispatch(
        PratDashboardMiddleware.downloadDttsXlsx(
          selectedCategory,
        )
      );
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DTTS);
